import { render, staticRenderFns } from "./InitialNursingCreate.vue?vue&type=template&id=cbcf965a&"
import script from "./InitialNursingCreate.vue?vue&type=script&lang=js&"
export * from "./InitialNursingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports